import React from 'react';
import { Stars } from './Stars';
import { coachTestimonials } from '../data/content';
export function CoachTestimonials() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-34" data-mp="14hv1ka10b642">
      <div className="mx-auto max-w-6xl" data-id="element-35" data-mp="1je3wizdv6xao">
        <div className="text-center" data-id="element-36" data-mp="1jf5ja148t888">
          <h2 className="font-display text-3xl font-black text-navy-800 sm:text-4xl" data-id="element-37" data-mp="1eehlmwlidt51">
            What <span className="text-gold-dark" data-id="element-38" data-mp="1egu89n27orof">coaches</span> are saying
          </h2>
          <p className="mt-3 text-sm font-medium text-slate-600" data-id="element-39" data-mp="1sc65c13uau8i">
            ⭐⭐⭐⭐⭐ 4.9/5 · 500+ coaches worldwide
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-40" data-mp="224llqtzhnara">
          {coachTestimonials.map(t => <figure key={t.name} className="flex h-full flex-col rounded-xl border border-slate-200 bg-slate-50 p-6" data-id="element-41" data-mp="1x60maws28v3w">
              <div className="flex items-center gap-3" data-id="element-42" data-mp="2735d59wuper1">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy-800 font-display text-sm font-bold text-gold" data-id="element-43" data-mp="274q7ayf96vod">
                  {t.initials}
                </span>
                <Stars data-id="element-44" data-mp="2ko4ucrezotot" />
              </div>
              <blockquote className="mt-4 text-[15px] leading-relaxed text-slate-700" data-id="element-45" data-mp="2pn7qfmczrpkn">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-5" data-id="element-46" data-mp="2unlwwzyy2rgk">
                <p className="font-display text-sm font-bold text-navy-800" data-id="element-47" data-mp="2zldm3m87fzh2">
                  {t.name}
                </p>
                <p className="text-xs text-slate-500" data-id="element-48" data-mp="33lnsv13tmtwz">{t.location}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}